import { DATA_PRODUCER_WORKSHEET_NAME } from "../globalValues";
import { DATA_PRODUCER_TABLE_NAME } from "./constants";
import { setProducerQuoteFeederOptions } from "./setProducerQuoteFeederOptions";

export async function updateProducerQuoteFeederOptions(context: Excel.RequestContext) {
  const sheet = context.workbook.worksheets.getItemOrNullObject(DATA_PRODUCER_WORKSHEET_NAME);
  const table = sheet.tables.getItemOrNullObject(DATA_PRODUCER_TABLE_NAME);
  await context.sync();

  if (table.isNullObject) return;

  await setProducerQuoteFeederOptions(context, sheet, table);
}
